import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WebUrl, ApiUrl, ApiKey, AlertTypes } from "../../util/Constant";
import Input from "../../components/custom/Input";
import SweetAlert from "react-bootstrap-sweetalert";
import { useForm } from "react-hook-form";
import ApiEngine from "../../util/ApiEngine.js";
import { useDispatch } from "react-redux";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction.js";
import { createFormBody } from "../../util/Util.js";
import CreateAccountSuccessDesktop from "components/desktop/CreateAccountSuccess";

const CreatePasswordDesktop = (props) => {
    var { t, i18n } = useTranslation();
    var _history = useHistory();
    let _location = useLocation();
    const _dispatch = useDispatch();
    const [inputType, setInputType] = useState("password");
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [isCreatePassword, setIsCreatePassword] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [password, setPassword] = useState("");
    const _MIN_PASSWORD_LENGTH = 9;
    const {
        register,
        handleSubmit,
        errors,
        clearErrors,
        setError,
        setValue,
        getValues,
        watch,
        control,
        trigger,
    } = useForm({
        mode: "onBlur",
    });
    // const backURL = WebUrl._URL_MLMCREATEANACCOUNT + "?code=" + _location.state.referralCode

    const submitPassword = async (data, e) => {
        _dispatch(setBusy());
        if (data.password == "") {
            setShowConfirmation(true);
        } else {
            let params = {
                username: props.username,
                //email: _location.state.email,
                password: data.password,
                phoneNumber: props?.phoneNumber,
                referralCode: props?.referralCode,
                isMemberOperate: true,
                languageSetting: "en",
                isPhoneVerify: true,
            };

            let responseJson = await ApiEngine.post(
                ApiUrl._API_CREATE_OR_UPDATE_MEMBER,
                createFormBody(params)
            );
            _dispatch(
                showMessage({
                    type: responseJson[ApiKey._API_SUCCESS_KEY]
                        ? AlertTypes._SUCCESS
                        : AlertTypes._ERROR,
                    content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
                    onConfirm: async () => {
                        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                            //if (typeof window.fbq === 'function') {
                            //    window.fbq('track', 'CompleteRegistration', {
                            //    value: 0.00,
                            //    currency: 'USD',
                            //    content_name: 'Registration',
                            //    status: 'success',
                            //    });
                            //} else {
                            //    console.warn('Facebook Pixel is not available.');
                            //}

                            //if (window.ttq) {
                            //  const eventId = `reg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
                            //  window.ttq.track('CompleteRegistration', {
                            //    event_id: eventId,
                            //    content_type: 'user',
                            //    description: 'User registration success'
                            //  });
                            //} else {
                            //    console.warn('Tiktok Pixel is not available.');
                            //}


                            if (responseJson[ApiKey._API_DATA_KEY]) {
                                setPassword(data.password);
                                setIsCreatePassword(false);
                                setIsSuccess(true);
                            } else {
                                window.location.replace('https://www.google.com')
                            }
                            
                        } else {
                            _dispatch(setIdle());
                        }
                    },
                })
            );
        }

        _dispatch(setIdle());
    };

    return (
        <>
            {isCreatePassword && (
                <>
                    {showConfirmation && (
                        <SweetAlert
                            warning
                            confirmBtnText={t("CONFIRM")}
                            confirmBtnBsStyle="danger"
                            title="Password is required"
                            onConfirm={() => {
                                setShowConfirmation(false);
                            }}
                        >
                            {t("PLEASE_INSERT_NEW_PASSWORD")}
                        </SweetAlert>
                    )}
                    <div>
                        <h3 className="mt-2 mb-4 text-center">
                            {t("CREATE_YOUR_PASSWORD")}
                        </h3>
                        <form className="margin-bottom-0 custom-form">
                            <div className="password-with-eye">
                                <label>{t("ENTER_YOUR_PASSWORD")}</label>
                                <Input
                                    ref={register({
                                        required: true,
                                        minLength: {
                                            value: _MIN_PASSWORD_LENGTH,
                                            message: t("MIN_CHARACTERS", {
                                                length: _MIN_PASSWORD_LENGTH,
                                            }),
                                        },
                                        pattern: {
                                            value: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/i,
                                            message: t("PASSWORD_MESSAGE"),
                                        },
                                    })}
                                    errors={errors}
                                    id="password"
                                    name="password"
                                    type={inputType}
                                    // label={t("ENTER_YOUR_PASSWORD")}
                                    placeholder={t("ENTER_YOUR_PASSWORD")}
                                    autoFocus
                                />
                            </div>
                            <div className="pl-2 pr-2">
                                <div className="font12 text-white second">
                                    {t("INCLUDE_AT_LEAST_9_CHARACTERS_CONTAINING_LETTER_AND_NUMBER")}
                                </div>
                            </div>
                            <div>
                                <div
                                    className="btn btn-custom font20 mt-4"
                                    onClick={() => {
                                        handleSubmit(submitPassword)();
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    {t("COMPLETE_PROFILE")}
                                </div>
                            </div>
                        </form>
                    </div>
                </>
            )}
           
            {isSuccess && (
                <>
                    <CreateAccountSuccessDesktop 
                        username={props?.username}
                        password={password}
                    />
                </>
            )}
        </>
    );
};

export default CreatePasswordDesktop;
